import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getOnboardingState } from '../../../store/selectors';
import { setModalImage } from '../../../store/actions';
import { fireGTM } from '../../../gtm/gtmUtil';
import { learnMore_GTM } from '../../../gtm/datalayers/utilDataLayers.json';

function LearnMoreLink(props) {
  const { t } = useTranslation();
  const learnMoreTextColor = props.primary
    ? {
        color: `${props.tenant.primary}`,
      }
    : {
        color: '#FFFFFF',
      };

  const handleLearnMoreGTMAndSetImage = () => {
    props.setModalImage(props.modalImage);

    const tempLearnMore_GTM = learnMore_GTM;

    tempLearnMore_GTM.component = props.component;
    fireGTM(tempLearnMore_GTM, 'learn more', props.section);
  };

  const content = t('Learn more');
  const mainContent = (
    <div
      className="learn-more-link learn-more"
      data-cy="learn-more-link"
      style={learnMoreTextColor}
      onClick={handleLearnMoreGTMAndSetImage}
      onKeyDown={handleLearnMoreGTMAndSetImage}
      role="link"
      tabIndex={0 || props.tabIndex}
      aria-label={props.ariaLabel}
    >
      {props.render ? props.render(content) : content}
    </div>
  );

  return mainContent;
}

function mapStateToProps(state) {
  const onboarding = getOnboardingState(state);

  return { onboarding };
}

export default connect(mapStateToProps, { setModalImage })(LearnMoreLink);
